var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    _vm._l(_vm.alerts, function(item, key) {
      return _c(
        "v-col",
        {
          key: key,
          attrs: {
            cols: "12"
          }
        },
        [
          _c("alert-item", {
            attrs: {
              alert: item
            }
          })
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }